module.exports = __webpack_public_path__ + "static/media/notificationOff.eaf66fde.svg";